<template>
  <!-- <a-modal 
    width="70%"
    title="围栏告警"
    v-model="visable"
    centered
    @ok="handleOk"
    @cancel="quit"
    destroyOnClose
  > -->
    <div class="area-map-border" v-if="selectInNode">
      <div class="area-map" id="areaMap"></div>
      <div class="cancelBtn" @click="cancelModal">X</div>
    </div>
  <!-- </a-modal> -->
</template>

<script>
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.pm";
import "leaflet.pm/dist/leaflet.pm.css";
import MovingMarker from "@/utils/movingMarker";
import moment from 'moment'
import config from '@/config'
import log from "../../lang/logs/log-cn";
export default {
  props: {
    alarmData: {
      required: true
    }
  },
  data () {
    return {
      visable: true,
      selectInNode: false,
      inMap: null,
      sceneData: []
    }
  },
  methods: {
    showModal() {
      this.selectInNode = true;
      this.getOrg();
    },
    getOrg() {
      this.$http.get(config.api.org_tree_url).then(resp => {
        let { code, result } = resp;
        if(code == 0) {
          this.getSceneList(result.scenes)
        }
      })
    },
    getSceneList(val) {
      this.$http.get(config.api.get_scenes_fence + val).then(resp => {
        let { code, result } = resp;
        if(code == 0) {
          this.sceneData = this.filterSceneList(result)
          this.showTileLayer(this.sceneData.data)
        }
      })
    },
    filterSceneList(data) {
      let { scene } = this.alarmData
      for(let i = 0; i < data.length; i++) {
        if(data[i].data.id == scene) {
          return data[i]
        }
        if(data[i].children && data[i].children.length) {
          let fonund = this.filterSceneList(data[i].children)
          if(fonund) {
            return fonund
          }
        }
      }
    },
    bdToArr(va){
      let sp = va.split(",")
      let arr = []
      sp.forEach(item => {
        let latLng = item.split("_")
        if(latLng.length == 2)
          arr.push(latLng)
      })
      return arr
    },
    showTileLayer(info) {
      if(this.inMap) this.inMap.remove();
      
      let map = L.map("areaMap", {
        minZoom: 1,
        maxZoom: 8,
        zoom: 6,
        crs: L.CRS.Simple,
        doubleClickZoom: false, // 禁用双击放大
        attributionControl: false, // 移除右下角leaflet标识
        zoomSnap: 0.1, //缩放倍数
        zoomControl: false,
      });
      this.inMap = map;
      let bounds = this.bdToArr(info.bounds)
      L.imageOverlay('https://zxsmart.cn' + info.map, bounds).addTo(this.inMap);
      this.inMap.fitBounds(bounds)

      let attr = JSON.parse(this.alarmData.attr)
      let arr = []
      attr.parameter.points[0].map(item => {
        arr.push([item.lat, item.lng])
      })
      let polygon = L.polygon(arr, {color: 'red',fill:false})
      polygon.addTo(this.inMap)
      
      // 中心名称
      let content = `<div style="
            font-size:12px; 
            white-space:nowrap; 
            max-height:100%; 
            display:flex;
            justify-content: center;
            align-items: center;
            color: #000;
            background: #fff;
            border-radius: 2px;
            padding: 0 3px;
        ">
        ${attr.name}
      </div>`;

      let markerIcon = L.divIcon({
        html: content, //marker标注
        className: "my-div-name-icon",
        iconSize: [40, 40], //marker宽高
      });
      L.marker(
        [polygon.getCenter().lat, polygon.getCenter().lng],
        {
          icon: markerIcon,
        }
      ).addTo(this.inMap);

      this.addMarker(this.alarmData)
    },
    addMarker(info) {
      let iconNormalImg = require("../../assets/images/marker_normal_icon.png")
      let content = `<div style="position:relative;" >
      <div style="position:absolute;
            font-size:12px; 
            white-space:nowrap; 
            max-height:100%; 
            width:100%;
            display:flex;
            justify-content: center;
            align-items: center;
            top:-18px;
            left:-0px;
            color:#000;
            ">${info.uniqueSign || ""}</div>
      <img src=${iconNormalImg} style="width: 25px; height: 25px;">
      </div>`;

      let myIcon = L.divIcon({
        html: content, //marker标注
        className: 123,
        iconSize: [25, 25], //marker宽高
        iconAnchor: [12.5, 25], //文字标注相对位置
      });
      let marker = L.marker([info.y, info.x], {icon: myIcon}).addTo(this.inMap)
      let con = `
        <p>${info.uniqueSign || info.entity}</p>
        <p>${this.$t('supervise.fenceType')}:${JSON.parse(info.attr).opt === 1 ? this.$t('global.forbidIn') : this.$t('global.forbidOut')}</p>
        <p>${moment(info.occurTime * 1000).format('YYYY-MM-DD HH:mm')}</p>
      `
      marker.bindTooltip(con, { offset: L.point(0, -45), direction: 'top', permanent: 'true' }).openTooltip();
    },
    cancelModal() {
      if(this.inMap) this.inMap.remove();
      this.inMap = null;
      this.selectInNode = false;
    }
  },
}
</script>
<style lang="less" scoped>
.area-map-border{
  position: fixed;
  top: 100px;
  left: 0;
  right: 0;
  bottom: 100px;
  margin: auto;
  z-index: 999;
  padding: 3px;
  border-radius: 10px;
  // background: #FFE6B0;
  width: 75%;
  height: 80vh;
}

.area-map{
  width: 100%;
  height: 100%;
  // background: rgba(209, 213, 209, 0.99);
  background-image: url('../../assets/images/bg.png');
  background-size: cover;
  border-radius: 10px;
}

.cancelBtn {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}

/deep/ .my-div-name-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .my-div-name-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
